"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRenewingSubscriptionStatus = exports.isStoppedSubscriptionStatus = exports.STOPPED_SUBSCRIPTION_STATUSES = exports.NewSubscriptionStatus = void 0;
var NewSubscriptionStatus;
(function (NewSubscriptionStatus) {
    NewSubscriptionStatus["Created"] = "Created";
    NewSubscriptionStatus["Active"] = "Active";
    NewSubscriptionStatus["PastDue"] = "PastDue";
    NewSubscriptionStatus["Canceled"] = "Canceled";
    NewSubscriptionStatus["Ended"] = "Ended";
})(NewSubscriptionStatus || (exports.NewSubscriptionStatus = NewSubscriptionStatus = {}));
exports.STOPPED_SUBSCRIPTION_STATUSES = [
    NewSubscriptionStatus.Canceled,
    NewSubscriptionStatus.Ended,
];
const isStoppedSubscriptionStatus = (status) => !!status && exports.STOPPED_SUBSCRIPTION_STATUSES.includes(status);
exports.isStoppedSubscriptionStatus = isStoppedSubscriptionStatus;
const isRenewingSubscriptionStatus = (status) => status === NewSubscriptionStatus.Active || status === NewSubscriptionStatus.PastDue;
exports.isRenewingSubscriptionStatus = isRenewingSubscriptionStatus;
